import { Component, OnInit } from '@angular/core';
import { InterfacesService } from '../interfaces.service';
import { TipoInterfaces } from '@shared/enums/TipoInterfaces';
import {NgxSpinnerService} from "ngx-spinner";
import {UntypedFormControl} from "@angular/forms";
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-interfaz-stock',
  templateUrl: './interfaz-stock.component.html',
  styleUrls: ['./interfaz-stock.component.scss']
})
export class InterfaceStockComponent implements OnInit {
  interfaces = [];
  interfacesFiltradas;
  interfazSeleccionada;
  error;
  mensajeError;
  cargandoInterfaces: boolean;
  buscadorFormControl = new UntypedFormControl();

  constructor(public interfacesService: InterfacesService, private spinner: NgxSpinnerService, private datePipe: DatePipe) {}

  ngOnInit(): void {
    this.obtenerDatosStock();
  }

  obtenerDatosStock() {
    this.cargandoInterfaces = true;
    this.spinner.show('spinnerGrafico');
    this.interfacesService.obtenerInterfazDesdeLogicApp(TipoInterfaces.STOCK).then(data => {
      this.error = false;
      const interfacesLista = this.transformarJSON(data);
      this.interfaces = [];
      this.interfaces = this.interfaces.concat(interfacesLista);
      this.interfacesFiltradas = this.interfaces;
      this.cargandoInterfaces = false;
      this.spinner.hide('spinnerGrafico');
    }).catch(() => {
      this.error = true;
      this.interfaces = [];
      this.interfacesFiltradas = this.interfaces;
      this.mensajeError = 'Error al conectarse con la interfaz Stock'
      this.cargandoInterfaces = false;
      this.spinner.hide('spinnerGrafico');
    })
  }

  filtrarInterfaces() {
    this.interfacesFiltradas = this.interfaces.filter(i => i.nombre.toLowerCase().includes(this.buscador.value.toLowerCase()));
  }

  transformarJSON(jsonData) {

    const interfazMapeo = {
      "Cenit": "CENIT",
      "StockSPL": "SPL"
    };
    return Object.keys(jsonData).map((key) => {
      const registros = jsonData[key];
      let estado = "SinError";
      const pendientes = [];
      const error = [];

      const encabezadoData = {
        "Cenit": {
          encabezados: ["Aeroplanta", "Id del registro", "Fecha", "Código producto", "Cantidad"],
          registros: (r) => [
            r.PLANT,
            r.ID_REGISTRO,
            this.formatearFecha(r.PSTNG_DATE),
            r.MATERIAL,
            r.ENTRY_QNT
          ]
        },
        "StockSPL": {
          encabezados: ["Aeroplanta", "Fecha", "Código producto", "Volumen de tanques", "Volumen de despachado", "Volumen recepcionado"],
          registros: (r) => [
            r.StockAeroplanta[0].Aeroplanta,
            this.datePipe.transform(r.StockAeroplanta[0].FechaInformacion, 'dd/MM/yyy HH:mm a'),
            r.StockAeroplanta[0].Producto,
            r.StockAeroplanta[0].VolumenTanques,
            r.StockAeroplanta[0].VolumenDespachado,
            r.StockAeroplanta[0].VolumenRecepcionado
          ]
        }
      }[key];

      registros.forEach(r => {
        const registroTransformado = encabezadoData.registros(r);
        if (r.Estado.toLocaleLowerCase() === "error") {
          estado = "error";
          error.push(registroTransformado);
        } else if (r.Estado.toLocaleLowerCase === "pendiente") {
          pendientes.push(registroTransformado);
          if (estado.toLocaleLowerCase() !== "error") {
            estado = "pendiente";
          }
        } else {
          pendientes.push(registroTransformado);
        }
      });

      // Si hay registros pendientes y el estado no es "ERROR", asegura que el estado sea "Pendiente"
      if (estado !== "error" && pendientes.length > 0) {
        estado = "pendiente";
      }
      const interfacesStock = {
        nombre: interfazMapeo[key],
        estado: estado,
        pendientes: {
          encabezados: encabezadoData.encabezados,
          registros: pendientes
        },
        error: {
          encabezados: encabezadoData.encabezados,
          registros: error
        }
      };
      return interfacesStock;
    });
  }

  formatearFecha(fecha) {
    return `${fecha.slice(0, 2)}/${fecha.slice(2, 4)}/${fecha.slice(4, 8)}`;
  }

  mostrarInterfaz(event) {
    this.interfazSeleccionada = event;
  }
  
  get buscador() {
    return this.buscadorFormControl;
  }
}
